import { communicationLogService } from '@/services/api/communicationLog.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { communicationLogModel } from '@/models/api/communicationLog.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    status: {
        list: true,
    },
};

export const COMMUNICATION_LOG_MODULE = "api/communicationLog";

// ACTIONS
export const GET_ALL_COMMUNICATION_LOG = 'getAllCommunicationLog';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_COMMUNICATION_LOG_SUCCESS = "allCommunicationLogSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";

export const actions = {
    [GET_ALL_COMMUNICATION_LOG]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        communicationLogService
            .getAll(filter)
            .then((result) => {
                commit(ALL_COMMUNICATION_LOG_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_COMMUNICATION_LOG_SUCCESS](state, {data}) {
        let communicationLogList = data.data || [];
        state.list.data = communicationLogList;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = communicationLogList.map(item => communicationLogModel(item));
        }
    },
    [FAILURE](state) {
        state.status = {
            list: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
        };
    },
};
